import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const usePaymentPlanTemplates = () => {
  const { user } = useAuth();
  
  const dynamicHook = useDynamicEntity({
    entityType: 'paymentPlanTemplates',
    gqlEntityKey: 'payment_plan_templates',
    queryName: 'GET_PAYMENT_PLAN_TEMPLATES_QUERY',
    createMutation: 'CREATE_PAYMENT_PLAN_TEMPLATE_MUTATION',
    updateMutation: 'UPDATE_PAYMENT_PLAN_TEMPLATE_MUTATION',
    deleteMutation: 'DELETE_PAYMENT_PLAN_TEMPLATE_MUTATION',
    updateVariableName: 'set',
    transformData: (template) => ({
      ...template,
      templateName: template.template_name,
      companyId: template.company_id,
      companyName: template.company?.name || `Company ${template.company_id}`,
      paymentSchedule: template.payment_schedule || [],
      status: template.status ? 'active' : 'inactive',
    }),
    transformFormData: (formData) => {
      return {
        template_name: formData.templateName,
        description: formData.description,
        year: parseInt(formData.year),
        payment_schedule: formData.paymentSchedule,
        company_id: formData.companyId || user?.companyId,
        status: formData.status === 'active',
      };
    },
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
    mutationPattern: 'paymentPlanTemplates',
    createVariableName: 'template',
    updateVariableName: '_set',
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { usePaymentPlanTemplates };
